import '.c7{position:relative;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.g4{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.c6{align-items:flex-start;}.ssr-plugin'
import '.u{padding:2rem;}.ssr-plugin'
import '.cc{background:var(--shades-white);}.ssr-plugin'
import '.m{overflow:hidden;}.ssr-plugin'
import '.i{position:absolute;}.ssr-plugin'
import '.il{top:50%;}.ssr-plugin'
import '.im{right:1rem;}.ssr-plugin'
import '.in{transform:translateY(-50%);}.ssr-plugin'
import '.io{width:120px;}.ssr-plugin'
import '.ip{height:120px;}.ssr-plugin'
import '.iq{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.hi{z-index:1;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.ir{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c7 a0 g4 a b q c6 u cc m"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="i il im in io ip iq a c q"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c7 hi a b c6 an ir"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
